import { Component, OnInit, ViewChild, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogRef
} from "@angular/material/dialog";
import { AuditService } from "@app/services/http/audit.service";
import { GridComponent } from "@app/view/shared/base-pages/base-data-table-page/grid.component";
import { RowExpanderConfig } from "@bryntum/grid-thin";
import { BaseAuditViewer } from "@app/view/shared/audits/base/base-audit-viewer";
import { MatCheckbox } from "@angular/material/checkbox";
import { DialogHeaderComponent } from "../../dialog-header/dialog-header.component";
import { NgxUiLoaderModule, NgxUiLoaderService } from "ngx-ui-loader";

@Component({
  selector: "app-ticket-audit-viewer",
  templateUrl: "./ticket-audit-viewer.component.html",
  styleUrls: ["./ticket-audit-viewer.component.css"],
  standalone: true,
  imports: [
    MatDialogContent,
    MatCheckbox,
    GridComponent,
    DialogHeaderComponent,
    NgxUiLoaderModule
  ]
})
export class TicketAuditViewerComponent
  extends BaseAuditViewer
  implements OnInit
{
  dialogRef = inject<MatDialogRef<TicketAuditViewerComponent>>(MatDialogRef);
  data = inject<{
    ticketId: number;
  }>(MAT_DIALOG_DATA);
  auditService: AuditService;
  private ngxUiLoaderService = inject(NgxUiLoaderService);

  public rowExpanderConfig: Partial<RowExpanderConfig> = {
    columnPosition: "first",
    renderer: async ({ record }) => {
      console.log("Rendering expander for record ", record);
      let renderString = `<ticket-audit-renderer style="width:100%" snapshot-id="${
        record.get("majorId") + "." + record.get("minorId")
      }" ticket-id="${record.get("entityId")}"></ticket-audit-renderer>`;
      console.log("renderString", renderString);
      return renderString;
    }
  };

  @ViewChild(GridComponent, { static: true }) auditGrid: GridComponent;

  constructor() {
    const auditService = inject(AuditService);

    super(auditService, "ticket");

    this.auditService = auditService;
  }

  ngOnInit(): void {
    this.ngxUiLoaderService.startLoader("audit-loader");
    setTimeout(() => {
      this.queryAudit(this.data.ticketId, "ticket", this.auditGrid);
      this.ngxUiLoaderService.stopLoader("audit-loader");
    }, 0);
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  async onIncludeSystemChange(event: any, auditGrid: any) {
    this.ngxUiLoaderService.startLoader("audit-loader");
    // Use setTimeout to allow the UI to update before processing
    setTimeout(() => {
      this.updateIncludeSystem(event, auditGrid);
      this.ngxUiLoaderService.stopLoader("audit-loader");
    }, 0);
  }
}
